import {LoginPage} from "./login";
import {SignUpPage} from "./signup";
import {ConsentScreenPage} from "./consent";

export const Pages = Object.assign({}, {
    Login: LoginPage,
    SignUp: SignUpPage,
    Consent: ConsentScreenPage,
})